module.exports = __webpack_public_path__ + "assets/img/44.c736f244.png";